import { useState } from 'react';

const FAQLastMinute = () => {
    const faqs = [
        {
          question: "What exactly are last-minute holiday deals?",
          answer: "Last-minute holiday deals are like those surprise flash sales you find online, but for travel! They're trips with departure dates typically within the next few weeks, sometimes even just days away.  Hotels, airlines, and resorts offer these deals to fill up empty rooms or seats, which means you can snag some seriously sweet discounts."
        },
        {
          question: "Where can I find the best last-minute holiday deals?",
          answer: "You're in the right place! Halo Holidays specializes in finding those hidden gems and flash sales for last-minute getaways. We keep our finger on the pulse of the travel world, so you don't have to.  Check out our Last-Minute Deals page for the latest offers, or sign up for our email alerts so you never miss a steal."
        },
        {
          question: "Are last-minute holidays only for flexible travelers?",
          answer: "While it helps to be a bit flexible with your dates and destinations, last-minute holidays aren't just for free spirits!  We often have deals for popular destinations and specific dates, so you might just find exactly what you're looking for, even if you have a particular place in mind."
        },
        {
          question: "Are last-minute holidays always cheaper?",
          answer: "Most of the time, yes!  Since hotels and airlines are looking to fill those last-minute spots, they're often willing to offer significant discounts to entice travelers.  However, it's always a good idea to compare prices and do your research to make sure you're getting a good deal."
        },
        {
          question: "What are some tips for booking a last-minute holiday?",
          answer: "Be flexible with your travel dates and destinations, pack light to avoid baggage fees, and be ready to book quickly when you find a deal you love!  Also, consider travel insurance in case any unexpected changes pop up.  And most importantly, embrace the spontaneity and get ready for an adventure!"
        }
      ];
      

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQLastMinute;
